import { Box } from '@mui/material';
import {
  groupNotificationWorkflowsByCategory,
  notificationWorkflowCategoryMessages,
  notificationWorkflows,
} from '../workflows';
import { NotificationPreferencesCategorySection } from './NotificationPreferencesCategorySection';
import { NotificationPreferencesValues } from './notification-preferences-types';

export type NotificationPreferencesFormProps = {
  values: NotificationPreferencesValues;
  disabled?: boolean;
  onChange: (next: NotificationPreferencesValues) => void;
};

/**
 * Presentational preferences form: workflow rows grouped by Knock category.
 * Persistence remains per workflow key (not Knock `categories`).
 */
export function NotificationPreferencesForm({
  values,
  disabled = false,
  onChange,
}: NotificationPreferencesFormProps) {
  const groups = groupNotificationWorkflowsByCategory(notificationWorkflows);

  return (
    <Box>
      {groups.map(({ category, workflows }, index) => (
        <NotificationPreferencesCategorySection
          key={category}
          title={notificationWorkflowCategoryMessages[category]}
          workflows={workflows}
          values={values}
          disabled={disabled}
          divider={index > 0}
          onChange={onChange}
        />
      ))}
    </Box>
  );
}
